import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LetterAvatars from './LetterAvatars';
import ClientProvider from './client';
export default createDemo(import.meta.url, LetterAvatars, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/avatars/demos/letter/LetterAvatars.tsx",
    "fileName": "LetterAvatars.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Avatar from '@mui/material/Avatar';\nimport Stack from '@mui/material/Stack';\nimport { deepOrange, deepPurple } from '@mui/material/colors';\n\nexport default function LetterAvatars() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Avatar>H</Avatar>\n      <Avatar sx={{ bgcolor: deepOrange[500] }}>N</Avatar>\n      <Avatar sx={{ bgcolor: deepPurple[500] }}>OP</Avatar>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 13,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Avatar from '@mui/material/Avatar';\nimport Stack from '@mui/material/Stack';\nimport { deepOrange, deepPurple } from '@mui/material/colors';\n\nexport default function LetterAvatars() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Avatar>H</Avatar>\n      <Avatar sx={{ bgcolor: deepOrange[500] }}>N</Avatar>\n      <Avatar sx={{ bgcolor: deepPurple[500] }}>OP</Avatar>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">H</",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "deepOrange"
              ],
              "[",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              "] }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">N</",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "deepPurple"
              ],
              "[",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              "] }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">OP</",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 13,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/Avatar",
      "@mui/material/Stack",
      "@mui/material/colors"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
